export default (axios) => ({
  /**
   * Get checkout cart
   *
   * @param params
   * @param {string} params.cart_unique_id
   * @returns {Promise}
   */
  getCheckoutCart(params) {
    return axios.get(`/checkout/get-cart`, {
      params,
    });
  },

  /**
   * Get checkout order
   *
   * @param params
   * @param {string} params.cart_unique_id
   * @returns {Promise}
   */
  getCheckoutOrder(params) {
    return axios.get(`/checkout/get-order`, {
      params,
    });
  },
});
